<ls-modal
  data-nested-translation="order.ticket-overlimit-warning.modalWindow.title"
  [title]="
    'order.ticket-overlimit-warning.modalWindow.title'
      | translate: { ticketLimitPerEmail: ticketLimitPerEmail() }
      | hideTranslation
  "
  [visible]="isModalOpen()"
  [closable]="false"
  [footerContent]="false"
>
  <div class="flex flex-wrap justify-content-center gap-1">
    <ls-button
      data-nested-translation="order.ticket-overlimit-warning.modalWindow.close"
      [styleClass]="'button-secondary'"
      [color]="'secondary'"
      [size]="'md'"
      [label]="'order.ticket-overlimit-warning.modalWindow.close' | translate | hideTranslation"
      (onClick)="onTicketOverLimitModalClosed($event)"
    ></ls-button>
  </div>
</ls-modal>
